import { mapStates, mapActions, mapMutations, mapGetters } from './../baseModule'

const collection = 'stocks'
const singleName = 'stock'
const pluralName = 'stocks'

const model = {
  eventId: '',
  manufacturerId: '',
  invoice: Number(),
  dateInvoice: Date(),
  invoicePowerCompany: Number(),
  dateInvoicePowerCompany: Date(),
  numberOfRefigerators: Number(),
  description: ''
}

const validations = {
  eventId: {
    required: true
  },
  manufacturerId: {
    required: true
  },
  invoice: {
    required: true
  },
  dateInvoice: {
    required: true
  },
  invoicePowerCompany: {
    required: true
  },
  dateInvoicePowerCompany: {
    required: true
  },
  numberOfRefigerators: {
    required: true
  },
  description: {
    required: true
  }
}

let getters = {...mapGetters()}
getters[singleName] = (state) => state.one
getters[pluralName] = state => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count,
  stocksOption: state => {
    let op = []
    for (let s of state.all) {
      op.push({
        value: s._id,
        label: `${s.description} (${s.numberOfRefigerators})`
      })
    }
    return op
  }
})

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model)
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/stocks.js